
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"routing","fill":"#646e7e"}},[_c('path',{attrs:{"d":"M4.105.941a3.09 3.09 0 013.1 2.384 4.363 4.363 0 01-1.619 4.146 2.142 2.142 0 01-1.483.592 2.165 2.165 0 01-1.489-.588l-.005-.005a4.379 4.379 0 01-1.605-4.147A3.1 3.1 0 014.105.941zm0 6a1.021 1.021 0 00.707-.281 3.416 3.416 0 001.292-3.083 1.965 1.965 0 00-2-1.511 1.973 1.973 0 00-2 1.51 3.432 3.432 0 001.287 3.08 1.044 1.044 0 00.711.282z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.868 9.941a3.361 3.361 0 011.918.589 2.968 2.968 0 011.2 1.793 4.347 4.347 0 01-1.624 4.15 2.145 2.145 0 01-1.485.59 2.17 2.17 0 01-1.497-.588 4.349 4.349 0 01-1.625-4.152 2.968 2.968 0 011.195-1.793 3.361 3.361 0 011.918-.589zm0 6a1.026 1.026 0 00.711-.281 3.4 3.4 0 001.3-3.081 1.982 1.982 0 00-2.011-1.513 1.982 1.982 0 00-2.017 1.51 3.4 3.4 0 001.3 3.08 1.048 1.048 0 00.721.282z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9 14.813H6.99a2.06 2.06 0 01-1.352-3.612l5.991-5.241a.924.924 0 00.26-1.039.922.922 0 00-.879-.608H9a.563.563 0 01-.562-.562A.563.563 0 019 3.188h2.01a2.048 2.048 0 011.932 1.336 2.05 2.05 0 01-.571 2.281l-5.992 5.244a.935.935 0 00.611 1.639H9a.563.563 0 010 1.125zM4.124 4.875h-.009a.75.75 0 110-1.5h.009a.75.75 0 010 1.5zM13.874 13.875h-.009a.75.75 0 110-1.5h.009a.75.75 0 010 1.5z"}})])])
          )
        }
      }
    